export default __webpack_public_path__ + "static/media/sliderCards_noThemeSelected.dc8f2568.svg";